import axios from 'axios';
import { authInterceptor, logout } from './auth-interceptor';

const notificationService = import.meta.env.VITE_RTC_URL;
const apiVersion = '/rtc/v1';

export const http = axios.create({
  baseURL: import.meta.env.PROD
    ? `${notificationService}${apiVersion}`
    : `${apiVersion}`,
  withCredentials: true,
});

http.interceptors.response.use((result) => {
  if (result.config.url === '/notification/index') {
    return {
      notifications: result.data,
      pagination: JSON.parse(result?.headers?.['x-pagination'] || '{}'),
    };
  }
  return result.data;
});

authInterceptor(http, {
  getAccessToken: () => {
    return localStorage.getItem('apiv1Auth');
  },

  shouldLogout: (error) => {
    const { config, response: { data = {} } = {} } = error;
    return (
      config.url !== '/auth' &&
      ['err_user_deleted', 'err_suspended', 'err_token_invalid'].some((error) =>
        data?.errors?.includes?.(error)
      )
    );
  },

  shouldRefresh: (error) => {
    const { response: { status, data = {} } = {} } = error;
    if (
      status === 401 &&
      (data?.code === 401 || data?.error === 'Unauthorized')
    ) {
      return true;
    }

    if (data?.errors?.includes?.('err_token_expired')) {
      return true;
    }

    return false;
  },

  logout: logout,
});
